import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';
import { ReportService } from 'src/app/services/reports/report.service';

@Component({
  selector: 'app-generatereport',
  templateUrl: './generatereport.component.html',
  styleUrls: ['./generatereport.component.css']
})
export class GeneratereportComponent implements OnInit {
  data : User;
  UserDataAny:any;
  filledReportUrl : any;
  hrReportUrl : any;

  constructor(private router: Router,private userService : UserService,
    private reportService : ReportService) { }

  
  ngOnInit() {
    // this.userService.getUsersData().subscribe(
    //   (data) => {
    //     this.UserDataAny = data;
    //     this.data = this.UserDataAny;
    //     console.log("user data"+this.data);
    //   }
    // )
    //this.getVendorReport();
    this.getFilledReportUrl();
    this.getHrReportUrl();
  }

  getVendorReport()
  {
    this.userService.getUsersData().subscribe(
      (data) => {
        this.UserDataAny = data;
        this.data = this.UserDataAny;
        console.log(this.data);
      }
    )
  }

  getFilledReportUrl()
  {
    this.reportService.getFilledOrderReportUrl().subscribe(
      (data : any) => {
        this.filledReportUrl = data.urlData; 
      }
    )
  }

  getHrReportUrl()
  {
    this.reportService.getHrOrderReportUrl().subscribe(
      (data : any) => {
        this.hrReportUrl = data.urlData; 
      }
    )
  }

}
